<div
  class="modal-backdrop"
  *ngIf="isOpen"
  (click)="close()"
>
  <div
    class="modal-content"
    (click)="$event.stopPropagation()"
  >
    <img
      class="modal-image"
      [src]="imageUrl"
      alt="Image Modal"
      loading="lazy"
      (error)="onImageError($event)"
    />
    <app-button
    class="close-button"
    (click)="close()"
    aria-label="Close modal"
    icon="close"
    type="primary-white"
    ></app-button>
  </div>
</div>
